import axios from "axios";

// Base-URL resolution:
//   - Local dev: REACT_APP_BACKEND_URL points to a different host (e.g. a preview URL) — use it.
//   - Production: The site may be served on the same origin as the API (e.g. nitinnarang.com).
//     If the current browser origin differs from the compiled-in URL, prefer the current
//     origin so the app self-heals across domain migrations. All /api/* routes are
//     routed to the backend by the platform ingress.
const BUILD_URL = process.env.REACT_APP_BACKEND_URL || "";

function resolveBaseUrl() {
  if (typeof window === "undefined") return BUILD_URL;
  try {
    const buildHost = BUILD_URL ? new URL(BUILD_URL).host : "";
    if (!buildHost || buildHost !== window.location.host) {
      return window.location.origin;
    }
  } catch (_e) {
    return window.location.origin;
  }
  return BUILD_URL;
}

export const API = `${resolveBaseUrl()}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("nn_admin_token");
  if (token && cfg.url && cfg.url.startsWith("/admin")) {
    cfg.headers.Authorization = `Bearer ${token}`;
  }
  return cfg;
});

export default client;
